import React from 'react'
import styles from '~/styles/atoms/progress/progress.module.scss'
import ProgressItem from '~/components/atoms/progress/ProgressItem'

interface Props<T> {
  statuses: T
  current: string|number
  translate(value: string|number): string
}

const Progress = <T,>({statuses, current, translate}: Props<T>) => {
  let completed = true
  return (
    <ul className={styles.progress}>
      <>
        {Object.keys(statuses).map((status: string|number, index: number) => {
          if (status == current) {
            completed = false
          }
          return (
            <ProgressItem
              key={status}
              text={translate(status)}
              active={status == current}
              completed={completed}
            />
          )
        })}
      </>
    </ul>
  )
}

export default Progress